var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24PxImprovingSkills01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-improving-skills-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75,6.34,17.66.25l-.8,1.88a11,11,0,1,0,5,5ZM11.29,11.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L15.44,10A3.88,3.88,0,0,1,16,12a4,4,0,1,1-4-4,3.88,3.88,0,0,1,2,.56Zm7.61-5-1,.41-1,.45.45-1,.41-1,.58-1.35,1.91,1.91ZM21,12a9,9,0,1,1-4.93-8L14.88,6.73a6,6,0,1,0,2.39,2.39L20,7.93A9,9,0,0,1,21,12Z",
    fill: "#242f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24PxImprovingSkills01);
export default __webpack_public_path__ + "static/media/24px-improving-skills-01.911924beab88f00c284cfb021010429b.svg";
export { ForwardRef as ReactComponent };